import * as React from "react";
import {DashboardNavbar} from "./DashboardNavbar";
import {IApplicationGuard, lazyInject, TypeDefs} from "@athena-portal/core";
import {TrustPilotFeedbackDialog} from "../modals/TrustPilotFeedbackDialog";
import {ICacheManager, ICustomerPortalService, resourcesHelper, Types} from "@falcon/services";
import {getWebChatScriptValueByPolicyNumber, WebChatPopUp} from "@falcon/plugin-falcon-journey";
import {Types as JourneyCoreTypeDefs, IJourneyRuntimeService} from "@athena-portal/plugin-journey";

import {finalize} from "rxjs/operators";

export default class FalconHeader extends React.Component {

    @lazyInject(TypeDefs.ApplicationGuard)
    private applicationGuard: IApplicationGuard;

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    @lazyInject(Types.CacheManager)
    private cacheManager: ICacheManager;

    @lazyInject(JourneyCoreTypeDefs.JourneyRuntimeService)
    private readonly journeyRuntimeService: IJourneyRuntimeService;

    public render() {
        const policyNumber = this.getPolicyNumberFromUrl();

        return (
            <React.Fragment>
                <div className="journey-bg min-h-450">
                    <div>
                        <img className="waves" src="/img/Flow-waves.svg" alt="Journey background waves"/>
                        <img className="clouds" src="/img/Flow-clouds.svg" alt="Journey background clouds"/>
                    </div>
                </div>
                <WebChatPopUp policyNumber={policyNumber}/>
                <DashboardNavbar logout={this.doLogout} applicationGuard={this.applicationGuard}/>
                {this.isTrustpilotEnabled() && <TrustPilotFeedbackDialog/>}
            </React.Fragment>
        );
    }

    private doLogout = () => {
        const policyNumber = this.getPolicyNumberFromUrl();
        const value: string = resourcesHelper.THEME === "Britannia" ? "motor" : getWebChatScriptValueByPolicyNumber(policyNumber);
        this.customerPortalService.activateReviewRequests(this.getPolicyNumberFromUrl()).subscribe(() => {
            history.pushState({}, "", "/dashboard");
            window.sessionStorage.clear();

            if (value && !this.isContentGuruEnabled()) {
                // Clears LiveChat conversation on logout.
                window.Genesys("command", "MessagingService.clearConversation");
                window.Genesys("command", "Messenger.close");
            }

            this.cacheManager.clearAll();
            this.deleteCookie("registerUnauthenticated");
            const redirectUrl = "".concat(window.location.origin, "/dashboard");
            this.journeyRuntimeService.destroySession()
                .pipe(
                    finalize(() => {
                        this.applicationGuard.logout({redirectUri : redirectUrl});
                    })
                )
                .subscribe({
                    error: err => {
                        console.error('Failed to destroy the Journey session!', err);
                    }
                });
        });
    };

    private deleteCookie(name: string): void {
        const appBaseUrl = window.location.hostname;
        let domain;
        if (appBaseUrl.includes("athenapaas.com")) {
            domain = "athenapaas.com";
        } else {
            domain = appBaseUrl;
        }
        document.cookie = name + "=;path=/;domain=" + domain + ";expires=Thu, 01-Jan-1970 00:00:01 GMT";
    }

    private getPolicyNumberFromUrl(): string {
        const url = window.location.href.replace(/\/$/, '');
        return url.slice(url.lastIndexOf('/') + 1);
    }

    private isTrustpilotEnabled(): boolean {
        return process.env.REACT_APP_TRUSTPILOT_ENABLED ? JSON.parse(process.env.REACT_APP_TRUSTPILOT_ENABLED) : true;
    }

    private isContentGuruEnabled(): boolean {
        return process.env.REACT_APP_CONTENT_GURU_ENABLED ? JSON.parse(process.env.REACT_APP_CONTENT_GURU_ENABLED) : false;
    };
}
